type TWO_FACTOR_AUTH_ERRORS = 'EXPIRED_OR_INVALID_CODE' | 'UNKNOWN_ERROR';

export class TwoFactorAuthError extends Error {
  name: TWO_FACTOR_AUTH_ERRORS;

  constructor(name: TWO_FACTOR_AUTH_ERRORS, message = name) {
    super(message);
    this.name = name;
  }
}
